import React from 'react';
import DebouncingInputFilter from "../../microComponents/tablePages/filter/DebouncingInputFilter";
import FilterSelectOption from "../../microComponents/tablePages/filter/FilterSelectOption";


const TopSearchUserManagement = () => {
    // const [branchList, setBranchList] = useState([]);
    // const [branchLoading, setBranchLoading] = useState(false);

    // const getDetailList = () => {
    //
    //     getFilterBranch((e) => {
    //         setBranchList([{label: 'همه', value: 0}, ...e])
    //     }, setBranchLoading)
    // }


    return (<div className='grid grid-cols-1 2xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4   gap-x-4  gap-y-5 mt-10   '>


        <FilterSelectOption data={{
            className: 'sm:hidden',
            placeholder: 'واحد',
            filterName: 'branch',
            // loading: branchLoading,
            // options: branchList
        }}/>

        <DebouncingInputFilter
            data={{
                className: 'sm:hidden',
                placeholder: ' نام کاربری',
                filterName: 'نام کاربری',

            }}
        />


    </div>);
};

export default TopSearchUserManagement;
